export default __webpack_public_path__ + "static/media/close-red-variant-2.646a10f3.svg";